var interf = {
    current:"topview",
    seatmap:{
        nodes_selected: []
    },
    topview:{
        nodes_selected: [],
        hash:{}
    },
    filtering:{
        ref : null,
        nodes : {
            sections: [],
            rows: [],
            seats: []
        }
    },
    navigation:{
        to: "",
        from: ""
    },
    window:{
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight,
        animation: requestAnimationFrame(interfaceWindowLoop)
    }
}

function interfaceIsMobile(){
    if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || $(window).width()<767) {
        return true;
    } else {
        return false;
    }
}

function interfaceMoveArrowsHideOnLimits(){
    if(viewer.limits) {
        if(viewer.limits.left_limit) {
            $("#move-left").addClass("hidden");
        }
        
        if(viewer.limits.right_limit) {
            $("#move-right").addClass("hidden");
        }
        
        if(viewer.limits.upper_limit) {
            $("#move-up").addClass("hidden");
        }
        
        if(viewer.limits.lower_limit) {
            $("#move-down").addClass("hidden");
        }
    }
    return null;
}

function interfaceMoveArrowsShow(){
    $("#move-up").removeClass("hidden");
    $("#move-down").removeClass("hidden");
    $("#move-left").removeClass("hidden");
    $("#move-right").removeClass("hidden");
    return null;
}
function interfaceMoveArrowsHide(){
    $("#move-up").addClass("hidden");
    $("#move-down").addClass("hidden");
    $("#move-left").addClass("hidden");
    $("#move-right").addClass("hidden");
    return null;
}

function interfaceReset(){
    interf = {
        current:"topview",
        seatmap:{
            nodes_selected: []
        },
        topview:{
            nodes_selected: []
        },
        filtering:{
            ref : null,
            nodes : {
                sections: [],
                rows: [],
                seats: []
            }
        },
        navigation:{
            to: "",
            from: ""
        },
        window:{
            innerWidth: window.innerWidth,
            innerHeight: window.innerHeight,
            animation: requestAnimationFrame(interfaceWindowLoop)
        }
    }
}
function interfaceResetFiltering(){
    interf.filtering = {
            ref : null,
            nodes : {
                sections: [],
                rows: [],
                seats: []
            }
        }
}

function interfaceWindowLoop() {
    
    var h = window.innerHeight;
    var bh = h - ($("#header-wrap").innerHeight() + $("#topbar").innerHeight() + $(".app-topbar.sub").innerHeight()+5);
    if(interfaceIsMobile()){
        bh = window.innerHeight - ($("#interface-btns-mobile").innerHeight() + $("#header-wrap").innerHeight() + $("#topbar").innerHeight()+1);

    }
    $("#main-interface").css("height", bh);
    interf.window.animation = requestAnimationFrame(interfaceWindowLoop);

    if(viewer && viewer.isLoaded()){
        if(interfaceIsMobile()){
            dvmHideLabs();
            $("#interface-btns-mobile").removeClass("hidden");
            $(".interface-btns-desktop").addClass("hidden");
        }else{
            $("#interface-btns-mobile").addClass("hidden");
            $(".interface-btns-desktop").removeClass("hidden");
            dvmShowLabs();
        }

        if(interfaceGetCurrent()!='view3d'){
            breadcrumbsShowToggle();
        }

        if(!interfaceIsMobile() && viewer.scaling_factor > viewer.min_scaling_factor && interf.current != "view3d") {
            interfaceMoveArrowsShow()
        } else {
            interfaceMoveArrowsHide()
        }
        interfaceMoveArrowsHideOnLimits();
        if(viewer.getMapId()=='blockmap'){
            menuBtnShow();
        }else{
            menuBtnHide();
        }
    }
}

function interfaceZoomHide(){
    $(".zoom-in-btn").addClass("hidden");
    $(".zoom-out-btn").addClass("hidden");
    return;
}

function interfaceZoomShow(){
    //if(!interfaceIsMobile()){
        $(".zoom-in-btn").removeClass("hidden");
        $(".zoom-out-btn").removeClass("hidden");
    //}
    return;
}

function interfaceMoveFSbtn(){
    if(interfaceIsMobile()){
        viewer_3d.interface.setInterfaceElementPosition("toggle-fullscreen","bottomcenter")
    }
    return;
}

function interfaceBackBtnShow(){
    $(".back-btn").removeClass("hidden");
    return null;
}

function interfaceFSBtnShow(){
    $(".fs-btn").removeClass("hidden");
    return null;
}
function interfaceFSBtnHide(){
    $(".fs-btn").addClass("hidden");
    return null;
}
function interfaceHomeBtnShow(){
    $(".home-btn").removeClass("hidden");
    return null;
}
function interfaceHomeBtnHide(){
    $(".home-btn").addClass("hidden");
    return null;
}
function interfaceGalleryArrowsToggle(){
    $(".glide__arrow").removeClass("hidden");
    if(interfaceIsMobile()){
        $(".glide__arrow").addClass("hidden");
    }
    return null;
}

function interfaceSetCurrent(current){
    interf.current = current;
    return interf;
}

function interfaceGetCurrent(){
    return interf.current;
}

function interfaceViewer3DBtnsHide(){
    $(".viewer-btn").addClass("hidden");
    return null;
}


function interfaceBackBtnHide(){
    $(".back-btn").addClass("hidden");
    return null;
}
function interfaceGalleryBtnHide(){
    $(".gallery-btn").addClass("hidden");
    return null;
}

function interfaceGalleryBtnShow(){
    $(".gallery-btn").removeClass("hidden");

    return null;
}


function interfaceMinimapHide(){
    $(".minimap").addClass("hidden")
    return null;
}
function interfaceMinimapShow(){
    if(!map_id_mini){
        return;
    }
    $(".minimap").removeClass("hidden")
    return null;
}

function interfaceBreadcrumbsValueHide(element){
    $(".bread-crumbs "+element).addClass("hidden");
    return null;
}
function interfaceZoomSetTopview(){
    $(".zoom-btns-interface").addClass("ci-topview");
    $(".zoom-btns-interface").removeClass("ci-seatmap");
    return null;
}
function interfaceZoomSetSeatmap(){
    $(".zoom-btns-interface").removeClass("ci-topview");
    $(".zoom-btns-interface").addClass("ci-seatmap");
    return null;
}
function interfaceSetTopview(){
    viewer_3d.close();
    viewer_3d.reset();
    interfaceViewerShow();
    interfaceViewer3DHide();
    interfaceBackBtnHide();
    interfaceMinimapHide();
    interfaceZoomSetTopview();
    interfaceZoomShow();
    interfaceBreadcrumbsValueHide(".section");
    interfaceBreadcrumbsValueHide(".rows");
    interfaceBreadcrumbsValueHide(".seat");

    interfaceHomeBtnHide();
    interfaceFSBtnHide();
    interfaceGalleryBtnHide();
    interfaceNavigationHide();
    menuBtnShow();
    interfaceHideInfobtns();

    viewer_mini.scaling_factor = viewer_mini.min_scaling_factor;

    breadcrumbsShowToggle();

    if(interfaceIsMobile()) {
        //interfaceZoomHide();
        interfaceMoveArrowsHide();
        viewer.scaling_factor = 2;
    }
    //interfaceTicketsMobileBtnHide();
    popoverDestroyAll();
    interfaceSetCurrent("topview");

}
function interfaceViewerShow(){
    $("#viewer").removeClass("hidden");
    return null;
}
function interfaceViewer3DHide(){
    $("#view3d").addClass("hidden");
    return null;
}

function interfaceSetSeatmap(){
    viewer_3d.reset();
    viewer_3d.close();
    interfaceViewerShow();
    interfaceViewer3DHide();
    interfaceViewer3DBtnsHide();
    dvmSeatmapSetStyles();
    if(integrationType=='bumper'){
        interfaceBackBtnHide();
    }else{
        interfaceBackBtnShow();
    }
    menuClose();
    menuBtnHide();

    interfaceMoveFSbtn();
    interfaceFSBtnHide();
    interfaceHomeBtnHide();
    interfaceZoomSetSeatmap();
    interfaceZoomShow();
    interfaceNavigationHide();
    interfaceMinimapShow();
    topnavbtnsShow();
    if(!interfaceIsMobile()) {
        interfaceHomeBtnHide();
        breadcrumbsShowToggle();
    }
    //interfaceTicketsMobileBtnHide();
    interfaceSetCurrent("seatmap");
    return null;
}

function interfacesetViewer3D(node){
    interfaceGalleryArrowsToggle();
    $("#viewer").addClass("hidden")
    $("#view3d").removeClass("hidden");
    interfaceSetNodeBC(node);
    interfaceSetCurrent('view3d');
    menuBtnHide();
    interfaceBackBtnShow();
    interfaceNavigationShow();
    //breadcrumbsHide
    return null;
}

function interfaceGoBack(){
    if (interfaceGetCurrent() === "seatmap") {
        console.log("entri 1")
        interfaceSetTopview();
        
        viewer.loadMap({
            venue_id: venue_id,
            map_id: topview_id
        })    
        .then(onLoadD2MSuccess)
        .catch(onLoadD2MError);
        
    } else if (interfaceGetCurrent() === 'view3d') {

        interfaceNavigationShow();
        if (interf.seatmap.nodes_selected[0].type=='seat'){
            interfaceSetSeatmap();
        }else{
            interfaceGoBack();
        }
    }
    popoverDestroyAll();
   
}

function interfaceGoHome(){
    viewer.loadMap({
        venue_id: venue_id,
        map_id: topview_id
    })
    .then(onLoadD2MSuccess)
    .catch(onLoadD2MError);
}

function interfaceBCSetColours(){
    for(let type in filtering_typereferenced){
        var ft = filtering_typereferenced[type];
        $("#top-guide").find(".section-lab").removeClass(type);
        $("#top-guide").find(".row-lab").removeClass(type);
        $("#top-guide").find(".seat-lab").removeClass(type);
        for(var i =0;i<ft.length;i++){
            var section_id = ft[i];
            if(interf.topview.nodes_selected.length>0 && interf.topview.nodes_selected[0].id == section_id){
                $(".bread-crumbs").find(".breadcrumbs-val").addClass(type);
                $("#top-guide").find(".section-lab").addClass(type);
                $("#top-guide").find(".row-lab").addClass(type);
                $("#top-guide").find(".seat-lab").addClass(type);
            }
            
        }
       // if(interf.topview.nodes_selected)
    }
}
function interfaceBCResetColours(){
    for(type in filtering_typereferenced){
        $(".bread-crumbs").find(".breadcrumbs-val").removeClass(type);
        $("#top-guide").find(".section-lab").removeClass(type);
        $("#top-guide").find(".row-lab").removeClass(type);
        $("#top-guide").find(".seat-lab").removeClass(type);
    }
    return null;
}

function interfaceGoViewer(){ 
    interfaceGalleryBtnShow();
    interface360BtnHide();
    interfaceFSBtnShow();
    viewer_3d.gallery.toggleCurrentView();
    interfaceMinimapShow();
    interfaceHomeBtnShow();
    interfaceNavigationShow();
}
function interface360BtnShow(){
    $(".viewer360-btn").removeClass("hidden");
    return null;
}
function interface360BtnHide(){
    $(".viewer360-btn").addClass("hidden");
    return null;
}

function interfaceGoGallery(){
    interfaceGalleryBtnHide();
    interface360BtnShow();

    interfaceFSBtnHide();
    viewer_3d.gallery.toggleCurrentView();
    interfaceNavigationHide();
    interfaceHomeBtnHide();
    interfaceMinimapHide();
    $(".glide__arrow--right").html("<span class='interface-btn-standard icon-arrow-right'></span>");
    $(".glide__arrow--left").html("<span class='interface-btn-standard icon-arrow-left'></span>");

    return null;
}

function interfaceSetNodeBC(obj) {
    $(".rows").addClass("hidden");
    $(".seat").addClass("hidden");
    $(".section").removeClass("hidden");

    $(".section-val").text(obj.id.split("_")[1]);

    var selected_nodes = viewer.getNodesByState("seat","selected");
    if(selected_nodes.length>0){
        var seat_id = selected_nodes[0].id.split("_")[1].split("-");
        $(".rows").removeClass("hidden");
        $(".seat").removeClass("hidden");
        $(".section").removeClass("hidden");
        if(interf.filtering.ref && !interfaceIsMobile()){
            $("#top-guide").addClass("filtered");
            //$(".section-lab").html("<span class='fa-slash sm-hidden'>|</span> Section");
        }
        $(".section-val").text(seat_id[0]);        
        $(".row-val").text(seat_id[1]);
        $(".seat-val").text(seat_id[2]);
    }
}

function interfaceSetTicketsURL(url){
    //Set link URL
    $(".tickets-link").attr("href",url);
    return null;
}

function interfaceTicketsMobileBtnHide(){
    $("#interface-btns-mobile .tickets-link").addClass("hidden");
    return null;
}

function interfaceTicketsMobileBtnShow(){
    $("#interface-btns-mobile .tickets-link").removeClass("hidden");
    return null;
}

function interfaceNavigationShow(){
    let current_mapid = viewer.getMapId();
    if(navigation.outdoor && navigation.outdoor[current_mapid]){
        $(".navigation").removeClass("hidden");
    }
}
function interfaceNavigationHide(){
    $(".navigation").addClass("hidden");
}

function interfaceSetNavigationReverse(){
    var aux = interf.navigation.to;
    interf.navigation.to = interf.navigation.from;
    interf.navigation.from  = aux;
    return interf.navigation;
}
function interfaceGetNavigation(){
    return interf.navigation
}

function interfaceSetInitialNavigation(){
    let current_mapid = viewer.getMapId();
    let current_seat_id = viewer_3d.getViewId().split("-");
    let current_row_id = current_seat_id[0]+"-"+current_seat_id[1];

    interf.navigation.to = null;
    interf.navigation.from = null;

    if(outdoor_indoor && outdoor_indoor[current_mapid] ){
        let indoor_id = outdoor_indoor[current_mapid][current_mapid];
        if(outdoor_indoor[current_mapid][current_row_id]){
            indoor_id = outdoor_indoor[current_mapid][current_row_id];
        }

        let suite_position = suites.indexOf(current_mapid);
        let default_title = "This seat comes with access to a Premium Area";

        if( suite_position>-1){
            default_title = "This seat comes with access to Suites";
        }else{
            if(vipnavigation[indoor_id]){
                default_title = "This seat comes with access to "+vipnavigation[indoor_id];
            }
        }
        let outdoor = {
            id: current_mapid,
            title: default_title,
        }
        let indoor ={
            id: indoor_id,
            title: default_title
        }

        interf.navigation.to = indoor;
        interf.navigation.from = outdoor;

    }
    return interf.navigation
}
function interfaceHideInfobtns(){
    $("#infoBtns").addClass("hidden");
    //mobile
    $("#interface-btns-mobile .vip-contact").addClass("hidden");
    $("#interface-btns-mobile .regular-contact").addClass("hidden");
    $("#interface-btns-mobile .moreinfo").addClass("hidden");
}
function interfaceShowInfobtns(){
    interfaceToggleContactbtns();
    if(!interfaceIsMobile()){
        $("#infoBtns").removeClass("hidden");
    }
}
function interfaceToggleContactbtns(){
    
    $(".vip-contact").addClass("hidden");
    $(".moreinfo").addClass("hidden");
    $(".regular-contact").addClass("hidden");

    if(section_types[viewer.getMapId()] === 'regular'){
        $(".vip-contact").addClass("hidden");
        $(".regular-contact").removeClass("hidden");
        $(".moreinfo").addClass("hidden");
        $(".callbtn").removeClass("hidden");

    }else{
        $(".moreinfo").removeClass("hidden");
        $(".vip-contact").removeClass("hidden");
        $(".regular-contact").addClass("hidden");
        $(".callbtn").removeClass("hidden");

    }

    //$(".infoBtns-mobile #callbtn").removeClass("hidden");
    
    return null;

}